import React, { Fragment } from 'react';
import styles from '../Dashboards.mod.less';
import MultiPanel from '../../common/MultiPanel';
import ReportTypeList from './ReportTypeList';
import ReportList from './ReportList';
import ReportInfo from './ReportInfo';
import {
  DASHBOARD_PANEL_CONTEXT_NOTE,
  DASHBOARD_PANEL_CONTEXT_WHITEBOARD,
} from '../constants';

/**
 * @typedef ReportPickerProps
 * @prop {*=} selectedReport
 * @prop {*=} setSelectedReport
 * @prop {*=} selectedReportType
 * @prop {*=} setSelectedReportType
 * @prop {*=} context
 * @prop {*=} defaultSelectedReportType
 * @prop {*=} additionalFetchParams
 * @prop {*=} emptyStateHeader
 * @prop {*=} emptyStateBody
 * @prop {*=} hideHeader
 */
/**
 * @type {React.FC<ReportPickerProps>}
 */
function ReportPicker({
  selectedReport,
  setSelectedReport,
  selectedReportType,
  setSelectedReportType,
  context,
  defaultSelectedReportType = null,
  additionalFetchParams = {},
  emptyStateHeader = null,
  emptyStateBody = null,
  hideHeader = false,
}) {
  return (
    <Fragment>
      {!hideHeader && (
        <div className={styles.ModalBodyTitle}>{`Select ${
          context === DASHBOARD_PANEL_CONTEXT_NOTE ||
          context === DASHBOARD_PANEL_CONTEXT_WHITEBOARD
            ? 'saved view'
            : 'a view'
        }`}</div>
      )}
      <div className={styles.ModalBodyContent}>
        <MultiPanel>
          <ReportTypeList
            selectedReportType={selectedReportType}
            setSelectedReportType={setSelectedReportType}
            setSelectedReport={setSelectedReport}
            context={context}
          />
          <ReportList
            defaultSelectedReportType={defaultSelectedReportType}
            selectedReportType={selectedReportType}
            selectedReport={selectedReport}
            setSelectedReport={setSelectedReport}
            context={context}
            additionalFetchParams={additionalFetchParams}
            emptyStateHeader={emptyStateHeader}
            emptyStateBody={emptyStateBody}
          />
          <ReportInfo selectedReport={selectedReport} />
        </MultiPanel>
      </div>
    </Fragment>
  );
}

export default ReportPicker;
